import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RatesComponent } from '@app/commonComponents/rates/rates.component';
import { SharedEnumService } from '@app/enums/shared-enum.service';
import { TimeEntryType } from '@app/models';
import { CompanySettings } from '@app/models/company-settings';
import { Rate } from '@app/models/rate';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-activity-type-modal',
  standalone: false,
  templateUrl: './activity-type-modal.component.html',
  styleUrl: './activity-type-modal.component.scss',
})
export class ActivityTypeModalComponent implements AfterViewInit {
  libraryForm: UntypedFormGroup;
  submittedForm = false;
  currentRates: Rate[] = [];
  listBillingMethod;
  changesRates;
  companySettings: CompanySettings;
  isManyCurrency
  sharedData = new SharedEnumService(this.translate);
  @ViewChild(RatesComponent, { static: false }) ratesComponent: RatesComponent;

  constructor(
    public dialogRef: MatDialogRef<ActivityTypeModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { value?: TimeEntryType, companySettings },
    private formBuilder: UntypedFormBuilder,
    private toastrService: ToastrService,
    private translate: TranslateService
  ) {
    this.listBillingMethod = this.sharedData.enumBillingMethod;
    this.companySettings = this.data?.companySettings;
    this.isManyCurrency = this.data?.companySettings?.isManyCurrency;
    this.createForm();

  }

  ngAfterViewInit() {
    if (this.data?.value) {
      this.initFormValues(this.data.value);
    }
  }

  onChangeBillingMethod(value) {
    this.ratesComponent.resetForm();
    this.ratesComponent.addRateField({
      currency: {
        code: this.companySettings.currency.code
      }
    });
  }




  closeModal() {
    this.dialogRef.close();
  }

  onLibraryCreate() {
    this.checkSubmit();
    this.libraryForm.updateValueAndValidity();
    if (!this.libraryForm.valid) {
      return;
    }
    const rates = this.ratesComponent.form.get('rates') as UntypedFormArray;

    const savedValue = {
      ...this.libraryForm.value,
      customRates: rates.value.map(el => ({
        currency: el.currency,
        amount: el.rate + ''
      }))
    };
    this.dialogRef.close(savedValue);
    this.toastrService.success(this.translate.instant('itemAdded'));
  }

  checkSubmit() {
    this.submittedForm = true;
  }

  get f() {
    return this.libraryForm;
  }

  private createForm() {
    this.libraryForm = this.formBuilder.group({
      name: this.formBuilder.control('', [Validators.required]),
      customRateType: this.formBuilder.control(this.listBillingMethod[0]?.value, [Validators.required]),
    });
  }

  private initFormValues(data: TimeEntryType): void {
    this.libraryForm.get('name').setValue(data.name);
    this.libraryForm.get('customRateType').setValue(data.customRateType);
    console.log(data.customRates);
    for (const rate of data.customRates) {
      this.ratesComponent.addRateField(rate);
    }
  }



  changeCurrentRates() {
    let temp;
    for (let i = 0; this.currentRates && i < this.currentRates.length; i++) {
      if (this.currentRates[i]) {
        if (this.currentRates[i].currency.code === this.getCurrency(this.companySettings.currency?.code)) {
          temp = this.currentRates[i];
          delete this.currentRates[i];
        }
      }
    }
    if (!temp) {
      temp = {
        currency: { code: this.getCurrency(this.companySettings.currency?.code) },
        rate: '0'
      };
    }
    this.currentRates.unshift(temp);
  }
  changedRates(rates) {
    this.changeCurrentRates();
    this.ratesComponent.resetForm();
    this.changesRates = rates;
  }

  getCurrency(currency) {
    if (currency && typeof currency === 'object') {
      return currency.code;
    } else {
      return currency;
    }
  }
}
